import React from 'react';
import { Check } from 'lucide-react';

const ONBOARDING_STEPS = [
  { id: 1, label: 'Connect Source' },
  { id: 2, label: 'Select Repo' },
] as const;

interface OnboardingProgressProps {
  currentStep: 1 | 2;
  className?: string;
}

const OnboardingProgress: React.FC<OnboardingProgressProps> = ({
  currentStep,
  className = 'max-w-2xl',
}) => {
  return (
    <div className="border-b border-ui-border-primary">
      <div className={`${className} mx-auto px-4 py-6`}>
        <div className="flex items-center justify-center">
          {ONBOARDING_STEPS.map((step, index) => {
            const isCompleted = step.id < currentStep;
            const isActive = step.id === currentStep;
            const isReached = isCompleted || isActive;

            return (
              <React.Fragment key={step.id}>
                <div className="flex items-center gap-2">
                  <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-colors ${
                      isReached
                        ? `bg-brand-primary text-black ${isActive ? 'ring-4 ring-brand-primary/20' : ''}`
                        : 'bg-ui-background-tertiary text-ui-text-tertiary'
                    }`}
                  >
                    {isCompleted ? <Check className="w-4 h-4" /> : step.id}
                  </div>
                  <span
                    className={`text-sm font-medium hidden sm:block ${
                      isReached
                        ? 'text-ui-text-primary'
                        : 'text-ui-text-tertiary'
                    }`}
                  >
                    {step.label}
                  </span>
                </div>
                {index < ONBOARDING_STEPS.length - 1 && (
                  <div
                    className={`w-12 h-1 mx-3 rounded-full transition-colors ${
                      step.id < currentStep ? 'bg-brand-primary' : 'bg-ui-border-primary'
                    }`}
                  />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default OnboardingProgress;
